import { fetcher } from "helpers/fetcher";

import { TGetCorpEmployeeMemberReq, TGetCorpEmployeeMemberRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCorpEmployeeMember = async (
  params?: TGetCorpEmployeeMemberReq,
  language?: string
) => {
  return await fetcher<TGetCorpEmployeeMemberRes, TGetCorpEmployeeMemberReq>(
    ENDPOINT.CORPORATION.GET_CORP_EMPLOYEE_MEMBER,
    {
      params: params?.data,
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.CORPORATION.GET_CORP_EMPLOYEE_ACCESS.version,
        [API_HEADER.CORP_ID]: params?.idCorp,
        [API_HEADER.LANGUAGE]: language,
      },
    }
  );
};

export const queryGetCorpEmployeeMember = async (
  params?: TGetCorpEmployeeMemberReq,
  language?: string
) => {
  return (await getCorpEmployeeMember(params, language)).data;
};

queryGetCorpEmployeeMember._key = (
  params?: TGetCorpEmployeeMemberReq,
  language?: string,
  key?: string
) => [ENDPOINT.CORPORATION.GET_CORP_EMPLOYEE_MEMBER.url, params, language, key];
